/**
 * @description Common Store Module
 * @author Fahid Mohammad
 */
import Vue from 'vue';
import http from '../../util/axios';
import i18n from '../../i18n';
import config from '../../config';
import { ConnectionStatus } from '../../util/common';

export default {
    namespaced: true,
    state: {
        incomingCall : {
            isRinging: false
        },
        connectionStatus: ConnectionStatus.DISCONNECTED
    },
    mutations: {
        INCOMING_CALL: (state, payload) => {
            state.incomingCall = payload
        },
        UPDATE_CALL_STATUS: (state, payload) => {
            state.connectionStatus = payload
        }
    },
    actions: {
        INCOMING_CALL ( { commit } , payload) {
            commit('INCOMING_CALL', payload)
        },
        UPDATE_CALL_STATUS ( { commit } , payload ) {
            commit('UPDATE_CALL_STATUS', payload)
        }
    },
    getters: {
        isRinging : state => { return state.incomingCall.isRinging },
        inCallStatus: state => { return state.connectionStatus },
        getIncomingCallPayload: state =>  state.incomingCall.data,
        callStatus: state => state.connectionStatus
    },

}



// WEBPACK FOOTER //
// ./src/store/modules/videocall.js